'use client';
import { Skeleton } from '@/components/Skeleton';
import { MediaType } from '@/helpers/enums';
import { useResponsive } from '@/modules/client';

const grid = {
  [MediaType.DESKTOP_L]: { cols: 6, rows: 3, size: 219 },
  [MediaType.DESKTOP]: { cols: 6, rows: 3, size: 168 },
  [MediaType.TABLET]: { cols: 4, rows: 3, size: 222 },
  [MediaType.MOBILE]: { cols: 3, rows: 3, size: 196 },
  [MediaType.MOBILE_S]: { cols: 2, rows: 3, size: 218 },
};

const modalGrid = {
  [MediaType.DESKTOP_L]: { cols: 4, rows: 3, size: 143 },
  [MediaType.DESKTOP]: { cols: 4, rows: 3, size: 143 },
  [MediaType.TABLET]: { cols: 4, rows: 3, size: 143 },
  [MediaType.MOBILE]: { cols: 4, rows: 3, size: 143 },
  [MediaType.MOBILE_S]: { cols: 2, rows: 3, size: 165 },
};

interface GamesSkeletonProps {
  withTitle?: boolean;
  isSearchModal?: boolean;
}

export default function GamesSkeleton({
  withTitle,
  isSearchModal,
}: GamesSkeletonProps) {
  const { currentMediaType } = useResponsive();

  const { cols, rows, size } = isSearchModal
    ? modalGrid[currentMediaType]
    : grid[currentMediaType];

  return (
    <div>
      {withTitle && (
        <Skeleton.Container
          gap={12}
          justifyContent="space-between"
          marginBottom={24}
        >
          <Skeleton.Rect height={40} width={250} />
          <Skeleton.Rect height={32} width={170} />
        </Skeleton.Container>
      )}
      <Skeleton.Container
        display="grid"
        gap={16}
        gridTemplateRows={`repeat(${rows}, 1fr)`}
        gridTemplateColumns={`repeat(${cols}, 1fr)`}
      >
        {new Array(cols * rows).fill(0).map((_, i) => (
          <Skeleton.Rect key={i} height={size} />
        ))}
      </Skeleton.Container>
    </div>
  );
}
